import React, { useEffect, useState } from 'react'
import { Button, TextField } from '@material-ui/core'
import { CustomModal } from '../../../../components/common/CustomModal'
// @ts-ignore
import { lookupUser } from '../../../../api/complianceService'
// @ts-ignore
import { openErrorMessage } from '../../../../actions/message'
import { LinkBiotrackUserProps } from './biotrackUserTypes'

export const LinkBiotrackUser = ({
  open,
  onClose,
  employee,
  assignedShop,
  dispatch,
  roles,
  onNextModal,
}: LinkBiotrackUserProps) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  useEffect(() => {
    if (open && employee?.email) {
      setUsername(employee.email)
    }
  }, [open, employee])

  const handleSync = async () => {
    if (!assignedShop?.companyId || !assignedShop?.id) return

    if (!password || !username) {
      return dispatch(openErrorMessage('User name and password are required.'))
    }

    const payload = {
      data: {
        attributes: { username, password },
      },
    }

    try {
      const response = await lookupUser(assignedShop.companyId, assignedShop.id, payload)
      if (response?.data?.attributes?.exists) {
        dispatch(openErrorMessage('User found'))
        onNextModal?.('none')
      } else {
        onNextModal?.('options', 'userNotFound')
      }
    } catch (error: any) {
      const detail = error?.response?.data?.errors?.[0]?.detail || 'Failed to sync user'
      dispatch(openErrorMessage(detail))
    }
  }

  return (
    <CustomModal open={open} onClose={onClose} size="medium">
      <CustomModal.Header
        title="Link Biotrack User"
        onClose={onClose}
        variant="caption"
        titleSx={{ textAlign: 'center' }}
      />
      <CustomModal.Content>
        <TextField
          fullWidth
          label="User name"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
        />
      </CustomModal.Content>
      <CustomModal.Footer alignment="center">
        <Button className="primary-button" onClick={handleSync}>
          Sync
        </Button>
      </CustomModal.Footer>
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/BiotrackUser/LinkBiotrackUser.tsx